import { BlockCopyPasteDirective } from './common/directives/block-copy-paste.directive';
import { NumbersOnlyDirective } from './common/directives/numbers-only.directive';
import { CmsService } from './services/cms.service';
import { ResourceService } from 'src/app/services/resource.service';
import { LoadingService } from './services/loading.service';
import { environment } from './../environments/environment';
import { ErrorInterceptor } from './auth/error.interceptor';
import { TokenInterceptor } from './auth/token.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { ViewsModule } from './views/views.module';
import { DataService } from './services/data.service';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import {GcuDateAdapter,APP_DATE_FORMATS} from 'src/app/common/adapters/GcuDateAdapter';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MatIconModule } from '@angular/material/icon';





import {LoaderInterceptorService} from 'src/app/common/Interceptor/LoaderInterceptorService';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete'
// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'Localization/getAllResources/', '');
}

@NgModule({
  declarations: [
    AppComponent,
    NumbersOnlyDirective,
    BlockCopyPasteDirective
  ],
  imports: [
    BrowserModule,
    ViewsModule,
    AppRoutingModule,
    MatIconModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleKey,
      libraries: ['geometry','places'],
      language: localStorage.getItem('lang')==null?'en':JSON.parse(localStorage.getItem('lang')).isoCode2
    }),
    MatGoogleMapsAutocompleteModule,
    TranslateModule.forRoot({
      //defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgbModule,


  ],
  providers: [
    ResourceService,
    {
      provide: APP_INITIALIZER,
      useFactory: resourceProviderFactory,
      deps: [ResourceService],
      multi: true
    },
    CmsService,
    {
      provide: APP_INITIALIZER,
      useFactory: cmsProviderFactory,
      deps: [CmsService],
      multi: true
    },
    LoadingService,
    DataService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {provide: DateAdapter, useClass: GcuDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function resourceProviderFactory(provider: ResourceService) {
  return () => provider.loadLanguages();
}
export function cmsProviderFactory(provider: CmsService){
  return () => provider.loadContent();
}


